declare var $: any;
import { Content } from './models/content.model';
import { Field } from './models/field.model';
import { SquidexDate } from './extensions/squidex-date.extension';
import { LanguageModel } from '../akita';

const EMPTY = '';

export class DataParser {

  currentLanguageCode: string;

  constructor(public readonly siteLanguages: LanguageModel[] = null) {
    if (this.siteLanguages) {
      if (!this.currentLanguageCode) {
        this.currentLanguageCode = this.getLanguageCode(this.findDefaultLanguage());
      }
    }
  }

  getData(content: Content, field: Field, language: string = 'iv'): any {
    return this.pullData(content, field.name, language);
  }

  /*
  * @description same as getData, with different signature, get and put are synonyms
  */
  pullData(content: Content, key: string, language: string = 'iv'): any {
    if (!content || !content.data || !key) {
      return EMPTY;
    }

    let d = content.data[key];

    let data: any;

    if (d) {
      data = d[language];
    } else {
      data = EMPTY;
    }

    return data;
  }

  setContent(content: Content, field: Field, newValue: string, languageCode: string = 'iv'): any {
    newValue = this.fixFieldValue(field.properties.editor, newValue, field.properties.fieldType);
    return this.setData(content.data, field, newValue, languageCode);
  }

  setData(data: any, field: Field, newValue: string, languageCode: string = 'iv'): any {
    newValue = this.fixFieldValue(field.properties.editor, newValue, field.properties.fieldType);
    return this.putData(data, field.name, newValue, languageCode, field);
  }

  // same as setData, with different signature, set and pull are synonyms
  putData(data: any, key: string, newValue: any, languageCode: string = 'iv', field?: Field): any {
    if (!data || !key) {
      return null;
    }

    if (field && field.properties.fieldType === 'Assets') {
      if (!data[key]) {
        data[key] = { 'iv': [] };
      }
      if (data[key].iv.length === 0) {
        data[key].iv = [];
      }
      if (Array.isArray(newValue)) {
        newValue.forEach(val => {
          if (!data[key].iv.includes(val)) {
            data[key].iv.push(val);
          }
        });
      } else {
        if (newValue) {
          data[key].iv.push(newValue);
        }
      }

    } else {
      if (field && field.properties.fieldType === 'Boolean') {
        if (newValue === '') {
          newValue = false;
        }
      }
      if (!data[key]) {
        data[key] = {};
      }

      data[key][languageCode] = newValue;
    }
    return data;

  }

  private fixFieldValue(editor: string, value: any, type: string): any {
    if (editor === 'DateTime') {
      return new SquidexDate(value).format();
    } else if ((editor === 'Dropdown' || editor === 'List') && !Array.isArray(value)) {
      return [value];
    } else if (type === 'Assets') {
      if (!value || value === "") {
        return [];
      } else if (Array.isArray(value)) {
        return value;
      } else {
        return [value];
      }
    } else if (type === 'Number') {
      return +value;  // simple way to parse to number
    } else if (type === 'References') {

      if (!(value instanceof Array)) {
        value = [value];
      }

      if (value[0] && value[0].item_id) {

        value = value.map(v => {
          if (v.item_id) {
            return v.item_id;
          }
          return v;
        });

      }

      return value;

    } else {
      return value;
    }

  }

  findDefaultLanguage(): LanguageModel {
    return this.siteLanguages.find(language => language.data.isdefault && language.data.isdefault.iv === true);
  }

  isDefaultLanguage(languageModel: LanguageModel): boolean {
    if (languageModel.data.isdefault && languageModel.data.isdefault.iv === true) {
      return true;
    } else {
      return false;
    }
  }

  getLanguageName(languageModel: LanguageModel): string {
    if (!languageModel || !languageModel.data) return '';
    return languageModel.data.name.iv;
  }

  getLanguageCode(languageModel: LanguageModel): string {
    if (!languageModel || !languageModel.data) return '';
    return languageModel.data.code.iv;
  }

  changeLanguage(langCode) {
    this.currentLanguageCode = langCode;
  }

  getCurrentDateTime() {
    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, 19).replace('T', ' ');
    return localISOTime;
  }
}
